// @flow
export const filterId: 'orgsOrUser' = 'orgsOrUser';
